export class MalformedAppSchemeError extends Error {}
